import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  Form,
  Input,
  Row,
  Col,
  Select,
  DatePicker,
  Spin,
  Table,
} from 'antd';
import { get, save, setPending } from '../redux/actions/contratoActions';
import { get as getAlquiler } from '../redux/actions/alquilerActions';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import dayjs from 'dayjs';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { compareObject } from '../utils/funtions';
import { callStatus } from '../utils/constants';
import { Notificacion } from './Notificacion';

import {
  DraggableModal,
  DraggableModalProvider,
} from 'ant-design-draggable-modal';
import { alquilerApi } from '../utils/api';
const { confirm } = Modal;

const ContratoEditor = ({
  dispatch,
  id,
  parentId,
  stateData,
  visible,
  onCancel,
  formaPagoContrato,
  parent,
  inversor,
  configuracion,
}) => {
  const [validateForma, setValidateForma] = useState(true);
  const [form] = Form.useForm();

  const [inversoresData, setInversoresData] = useState([]);
  const [loadingInversores, setLoadingInversores] = useState(false);
  const [inversoresList, setInversoresList] = useState([]);

  const [propietariosData, setPropietariosData] = useState([]);
  const [loadingPropietarios, setLoadingPropietarios] = useState(false);

  const isInversorUnico =
    configuracion?.list?.data?.find((c) => c.nombre === 'inversor_unico')
      ?.valor === '1';

  const format = 'YYYY-MM-DD';
  const formatDisplay = 'DD/MM/YYYY';

  useEffect(() => {
    if (parentId) {
      setLoadingInversores(true);
      alquilerApi
        .get(`inversores/${parentId}`)
        .then((response) => {
          setInversoresData(response.data);
        })
        .catch(() => {
          Notificacion('Error al cargar inversores', 'error', () => {});
        })
        .finally(() => {
          setLoadingInversores(false);
        });

      setLoadingPropietarios(true);
      alquilerApi
        .get(`propietarios/${parentId}`)
        .then((response) => {
          setPropietariosData(response.data);
        })
        .catch(() => {
          Notificacion('Error al cargar propietarios', 'error', () => {});
        })
        .finally(() => {
          setLoadingPropietarios(false);
        });
    } else {
      setInversoresData([]);
      setPropietariosData([]);
    }
  }, [parentId]);

  useEffect(() => {
    if (inversoresData.length > 0) {
      const data = stateData.object?.data || {};
      const savedInversores = data.contrato_inversores || [];
      const list = inversoresData.map((inv) => {
        const found = savedInversores.find((si) => si.inversor_id === inv.id);
        return {
          inversor_id: inv.id,
          inversor_nombre: inv.nombre,
          porcentaje: found ? found.porcentaje : 0,
        };
      });
      setInversoresList(list);
    } else {
      setInversoresList([]);
    }
    // eslint-disable-next-line
  }, [inversoresData, stateData.object?.data]);

  const columnsInversor = [
    {
      title: 'Nombre',
      dataIndex: 'inversor_nombre',
    },
    {
      title: 'Porcentaje %',
      dataIndex: 'porcentaje',
      render: (text, record) => (
        <Input
          type="number"
          value={text}
          onChange={(e) => {
            const val = e.target.value;
            setInversoresList((prev) =>
              prev.map((i) =>
                i.inversor_id === record.inversor_id
                  ? { ...i, porcentaje: val }
                  : i
              )
            );
          }}
        />
      ),
    },
  ];

  useEffect(() => {
    if (id) {
      if (String(stateData.object.data?.id) !== String(id)) {
        dispatch(get(id));
      }
    } else {
      dispatch(setPending());
    }
    // eslint-disable-next-line
  }, [id, dispatch]);

  useEffect(() => {
    if (parentId && String(parent.object.data?.id) !== String(parentId)) {
      dispatch(getAlquiler(parentId));
    }
    // eslint-disable-next-line
  }, [parentId, dispatch]);

  useEffect(() => {
    let data = cloneDeep(stateData.object.data);
    data['fecha'] = moment(moment(data.fecha));

    if (
      data.id &&
      data.alquiler_propietario_id &&
      parent.object.data?.alquiler_propietarios
    ) {
      const realPropietario = parent.object.data.alquiler_propietarios.find(
        (p) => p.id === data.alquiler_propietario_id
      );
      if (realPropietario) {
        data.alquiler_propietario_id = realPropietario.propietario_id;
      }
    }

    if (
      stateData.object.status === callStatus.OBJECT_SUCCESS ||
      stateData.object.status === callStatus.OBJECT_SAVE_SUCCESS
    ) {
      data['fecha'] = moment(moment(data.fecha));
      if (isInversorUnico) {
        if (data.contrato_inversores && data.contrato_inversores.length > 0) {
          data.inversor_id = data.contrato_inversores[0].inversor_id;
        }
      }
      if (!id) {
        data.forma_pago_id = 1;
      } else {
        if (data.forma_pago_id === 1) {
          setValidateForma(true);
        } else {
          setValidateForma(false);
        }
      }
    }

    if (stateData.object.status === callStatus.OBJECT_PENDING) {
      form.resetFields();
      setInitial({});
    } else if (stateData.object.status === callStatus.OBJECT_SAVE_SUCCESS) {
      if (isSaving) {
        setIsSaving(false);
        Notificacion('El registro se guardó con éxito', 'success', onCancel);
      }
    } else if (stateData.object.status === callStatus.OBJECT_FAILED) {
      if (isSaving) {
        setIsSaving(false);
        Notificacion(stateData.object.error, 'error', () => {});
      }
    }
    form.setFieldsValue(data);
    setInitial(data);
    // eslint-disable-next-line
  }, [stateData.object]);

  const [isSaving, setIsSaving] = useState(false);
  const [initial, setInitial] = useState({});

  const handleOnCancel = () => {
    if (compareObject(initial, form.getFieldsValue())) {
      confirm({
        title: 'Posee cambios sin guardar, desea continuar?',
        icon: <ExclamationCircleOutlined />,
        okText: 'Si',
        cancelText: 'No',
        autoFocusButton: 'cancel',
        onOk() {
          onCancel();
        },
        onCancel() {},
      });
    } else {
      onCancel();
    }
  };

  const onCreate = (data) => {
    data.fecha = dayjs(new Date(data.fecha).toISOString()).format(format);
    data.alquiler_id = parentId;

    if (
      data.alquiler_propietario_id &&
      parent.object.data?.alquiler_propietarios
    ) {
      const realPropietario = parent.object.data.alquiler_propietarios.find(
        (p) => p.propietario_id === data.alquiler_propietario_id
      );
      if (realPropietario) {
        data.alquiler_propietario_id = realPropietario.id;
      }
    }

    if (isInversorUnico) {
      data.inversores = [
        {
          inversor_id: data.inversor_id,
          porcentaje: 100,
        },
      ];
    } else {
      const sum = inversoresList.reduce(
        (acc, curr) => acc + parseFloat(curr.porcentaje || 0),
        0
      );
      const isValid = inversoresList.every((inv) => {
        const val = parseFloat(inv.porcentaje || 0);
        return val >= 0 && val <= 100;
      });

      if (!isValid) {
        Notificacion(
          'Todos los porcentajes deben estar entre 0 y 100',
          'error',
          () => {}
        );
        return;
      }
      if (sum !== 100) {
        Notificacion(
          `La suma de los porcentajes debe ser exactamente 100. (Suma actual: ${sum})`,
          'error',
          () => {}
        );
        return;
      }

      data.inversores = inversoresList.map((inv) => ({
        inversor_id: inv.inversor_id,
        porcentaje: parseFloat(inv.porcentaje),
      }));
    }

    dispatch(save(data));
    setIsSaving(true);
  };

  const handleChangeForma = () => {
    calcToneladas();
    if (form.getFieldValue('forma_pago_id') === 1) {
      setValidateForma(true);
      form.setFieldsValue({
        toneladas_total: null,
        superficie: null,
        toneladas: null,
      });
    } else {
      setValidateForma(false);
      form.setFieldsValue({
        importe: null,
      });
    }
  };
  useEffect(() => {
    form.validateFields([
      'importe',
      'superficie',
      'toneladas',
      'toneladas_total',
    ]);
    // eslint-disable-next-line
  }, [validateForma]);

  const calcToneladas = () => {
    const forma = form.getFieldValue('forma_pago_id');

    const superficie = form.getFieldValue('superficie');
    const toneladas = form.getFieldValue('toneladas');

    if (forma === 2 && superficie && toneladas) {
      const toneladas_total = superficie * toneladas;
      form.setFieldsValue({ toneladas_total: toneladas_total.toFixed(3) });
    }
  };

  return (
    <>
      <DraggableModalProvider>
        <DraggableModal
          mask
          initialWidth={500}
          initialHeight={500}
          maskClosable={false}
          visible={visible}
          title={
            stateData.object.data?.id
              ? `Editar Contrato ${stateData.object.data.numero || ''}`
              : 'Nuevo Contrato'
          }
          okText="Guardar"
          cancelText="Salir"
          onCancel={handleOnCancel}
          onOk={() => {
            form
              .validateFields()
              .then((values) => {
                onCreate(values);
              })
              .catch((info) => {
                console.log('Validate Failed:', info);
              });
          }}
        >
          <Spin
            spinning={
              stateData.object.status === callStatus.OBJECT_IN_PROCESS ||
              !!(id && stateData.object.status === callStatus.OBJECT_PENDING)
            }
          >
            <Form form={form} layout="vertical" name="form_in_modal">
              <Row gutter={[8, 0]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item name="id" label="id" style={{ display: 'none' }}>
                    <Input />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[8, 0]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  {isInversorUnico ? (
                    <Form.Item
                      name="inversor_id"
                      label="Aportante"
                      rules={[{ required: true, message: 'Requerido' }]}
                    >
                      <Select allowClear loading={loadingInversores}>
                        {inversoresData.map((item) => (
                          <Select.Option key={item.id} value={item.id}>
                            {item.nombre}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  ) : (
                    <Form.Item label="Inversores involucrados">
                      <Table
                        dataSource={inversoresList}
                        columns={columnsInversor}
                        rowKey="inversor_id"
                        pagination={false}
                        size="small"
                        loading={loadingInversores}
                      />
                    </Form.Item>
                  )}
                </Col>

                {!parent.object.data?.contrato_unico && (
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Form.Item
                      name="alquiler_propietario_id"
                      label="Propietario"
                      rules={[
                        {
                          required: true,
                          message: 'Requerido',
                        },
                      ]}
                    >
                      <Select allowClear loading={loadingPropietarios}>
                        {propietariosData.map((item) => (
                          <Select.Option key={item.id} value={item.id}>
                            {item.nombre}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                )}

                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                  <Form.Item
                    name="fecha"
                    label="Fecha"
                    rules={[
                      {
                        required: true,
                        message: 'Requerido',
                      },
                    ]}
                  >
                    <DatePicker
                      format={formatDisplay}
                      style={{ width: '100%' }}
                      initialValue={moment(new Date())}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                  <Form.Item
                    name="forma_pago_id"
                    label="Modalidad Pago"
                    rules={[
                      {
                        required: true,
                        message: 'Requerido',
                      },
                    ]}
                  >
                    <Select onChange={handleChangeForma}>
                      {formaPagoContrato.list.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.nombre}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col
                  xs={24}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  style={
                    validateForma ? { display: 'none' } : { display: 'block' }
                  }
                >
                  <Form.Item
                    name="superficie"
                    label="Superficie"
                    rules={[
                      {
                        required: !validateForma,
                        message: 'Requerido',
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      addonBefore="Ha"
                      onBlur={calcToneladas}
                    />
                  </Form.Item>
                </Col>

                <Col
                  xs={24}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  style={
                    validateForma ? { display: 'none' } : { display: 'block' }
                  }
                >
                  <Form.Item
                    name="toneladas"
                    label="Toneladas x HA"
                    rules={[
                      {
                        required: !validateForma,
                        message: 'Requerido',
                      },
                    ]}
                  >
                    <Input type="number" onBlur={calcToneladas} />
                  </Form.Item>
                </Col>

                <Col
                  xs={24}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  style={
                    validateForma ? { display: 'none' } : { display: 'block' }
                  }
                >
                  <Form.Item
                    name="toneladas_total"
                    label="Toneladas Totales"
                    rules={[
                      {
                        required: !validateForma,
                        message: 'Requerido',
                      },
                    ]}
                  >
                    <Input type="number" onBlur={calcToneladas} />
                  </Form.Item>
                </Col>

                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  style={
                    !validateForma ? { display: 'none' } : { display: 'block' }
                  }
                >
                  <Form.Item
                    name="importe"
                    label="Importe"
                    rules={[
                      {
                        required: validateForma,
                        message: 'Requerido',
                      },
                    ]}
                  >
                    <Input addonBefore="U$D" />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </DraggableModal>
      </DraggableModalProvider>
    </>
  );
};

const mapStateToProps = (state) => {
  const { contrato, inversor, formaPagoContrato, alquiler, configuracion } =
    state;
  const stateData = contrato;
  const parent = alquiler;
  return {
    stateData,
    inversor,
    formaPagoContrato,
    parent,
    configuracion,
  };
};
export default connect(mapStateToProps)(ContratoEditor);
